module.exports = __webpack_public_path__ + "static/media/rafflesmarina_4.3c40772f.jpg";